import { NgModule } from '@angular/core';
import { AddAddressMediumComponent } from '~shared/svgs/add-address-medium/add-address-medium.component';


@NgModule({
  declarations: [
    AddAddressMediumComponent
  ],
  exports: [
    AddAddressMediumComponent
  ]
})
export class AddAddressMediumModule {}
